import TextLink from "components/shared/TextLink/TextLink";
import styled from "styled-components";
import colours from "styles/colours";
import fonts from "styles/fonts";

export const ArrowCircle = styled.span`
  color: ${colours.white};
  background-color: ${colours.elexonBlue};
  border-radius: 50%;
  width: 2em;
  aspect-ratio: 1;
  display: inline-grid;
  place-items: center;
  font-size: ${fonts.small};
  cursor: inherit;
  transition: color 350ms ease-in-out, background-color 350ms ease-in-out;
`;

export const StyledContainer = styled(TextLink)`
  display: inline-flex;
  align-items: center;
  font-size: 1rem;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 2.4px;
  gap: 20px;
  color: ${colours.elexonBlack};
  cursor: pointer;
  text-decoration: none;

  &:hover,
  &:focus {
    color: ${colours.elexonBlack};
  }

  &:hover ${ArrowCircle}, &:focus ${ArrowCircle} {
    background-color: ${colours.elexonNeonGreen};
    color: ${colours.elexonBlack};
  }
`;
